(function () {
  'use strict';

  var form = document.getElementById('WsFilterForm');
  if (!form) return;

  // Section-ID fuer die Section Rendering API aus dem Shopify-Wrapper ableiten.
  var sectionEl = form.closest('.shopify-section');
  var sectionId = sectionEl ? sectionEl.id.replace(/^shopify-section-/, '') : null;

  var canAjax = !!(
    sectionId &&
    window.fetch &&
    window.DOMParser &&
    window.URLSearchParams &&
    window.FormData &&
    window.AbortController &&
    window.history &&
    window.history.pushState
  );

  var appliedSearch = window.location.search;
  var activeController = null;

  // Screen-Reader-Statusregion — bewusst ausserhalb der getauschten DOM-Bereiche.
  var status = null;
  if (canAjax) {
    status = document.createElement('div');
    status.setAttribute('aria-live', 'polite');
    status.style.cssText =
      'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;';
    document.body.appendChild(status);
  }

  function submitForm() {
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  }

  // Delegation auf dem Formular (nicht auf den Inputs), damit die Listener den
  // Sidebar-DOM-Austausch nach jedem AJAX-Update ueberleben.
  form.addEventListener('change', function (ev) {
    var t = ev.target;
    if (t && t.matches('input[type="checkbox"]')) submitForm();
  });

  // Preis-Range: debounced statt bei jedem Tastendruck feuern.
  var priceDebounceTimer;
  form.addEventListener('input', function (ev) {
    if (ev.target && ev.target.matches('.ws-filter__price-input')) {
      clearTimeout(priceDebounceTimer);
      priceDebounceTimer = setTimeout(submitForm, 500);
    }
  });

  // Sortier-Dropdown ist form-assoziiert (form="WsFilterForm"), liegt aber in der
  // Produktspalte und wird mitgetauscht -> Delegation auf document.
  document.addEventListener('change', function (ev) {
    if (ev.target && ev.target.id === 'SortBy') submitForm();
  });

  // "Zuruecksetzen" ohne Vollreload abwickeln.
  document.addEventListener('click', function (ev) {
    if (!canAjax || !ev.target.closest) return;
    var link = ev.target.closest('.ws-filter__reset');
    if (!link || !form.contains(link)) return;
    ev.preventDefault();
    renderPage(link.href, true);
  });

  form.addEventListener('submit', function (ev) {
    if (!canAjax) return; // natives GET-Submit als Fallback
    ev.preventDefault();
    var params = new URLSearchParams(new FormData(form)).toString();
    var url = form.action.split('?')[0] + '?' + params;
    renderPage(url, true);
  });

  // Vor/Zurueck-Button: Zustand konsistent per Reload wiederherstellen.
  window.addEventListener('popstate', function () {
    if (window.location.search !== appliedSearch) window.location.reload();
  });

  function renderPage(url, push) {
    var productsEl = document.getElementById('ws-produkte');
    if (productsEl) productsEl.classList.add('ws-products--loading');

    if (activeController) activeController.abort();
    var ctrl = new AbortController();
    activeController = ctrl;

    var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);

    fetch(fetchUrl, { signal: ctrl.signal })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newProducts = doc.getElementById('ws-produkte');
        var newForm = doc.getElementById('WsFilterForm');
        var oldProducts = document.getElementById('ws-produkte');
        if (!newProducts || !newForm || !oldProducts) {
          window.location.href = url;
          return;
        }

        // Offene (nicht kollabierte) Filtergruppen + Fokus vor dem Tausch merken.
        var openGroups = [];
        form.querySelectorAll('.ws-filter__group').forEach(function (g) {
          if (!g.classList.contains('ws-filter__group--collapsed')) {
            var t = g.querySelector('.ws-filter__group-toggle');
            openGroups.push(t ? t.textContent.trim() : '');
          }
        });
        var focusDesc = null;
        var ae = document.activeElement;
        if (ae && form.contains(ae) && ae.name) {
          focusDesc = { name: ae.name, value: ae.value };
        }

        // Produktspalte komplett ersetzen, Sidebar-Inhalt neu setzen (Checkbox-
        // Zustaende und Zaehler kommen serverseitig korrekt aus dem Fragment).
        oldProducts.replaceWith(newProducts);
        form.innerHTML = newForm.innerHTML;

        // Vom Nutzer geoeffnete Gruppen wieder oeffnen (Match ueber Gruppentitel).
        form.querySelectorAll('.ws-filter__group').forEach(function (g) {
          var t = g.querySelector('.ws-filter__group-toggle');
          var label = t ? t.textContent.trim() : '';
          if (openGroups.indexOf(label) > -1) {
            g.classList.remove('ws-filter__group--collapsed');
            if (t) t.setAttribute('aria-expanded', 'true');
          }
        });

        // Fokus auf das zuvor bediente Element zurueckholen.
        if (focusDesc) {
          var candidates = form.querySelectorAll('[name="' + focusDesc.name + '"]');
          var target = null;
          for (var i = 0; i < candidates.length; i++) {
            if (candidates[i].value === focusDesc.value) { target = candidates[i]; break; }
          }
          if (!target && candidates.length) target = candidates[0];
          if (target) target.focus({ preventScroll: true });
        }

        if (push) {
          try { history.pushState({ wsFilter: true }, '', url); } catch (_) {}
        }
        appliedSearch = new URL(url, window.location.origin).search;

        if (status) {
          var countEl = document.querySelector('.ws-products__count');
          status.textContent = countEl
            ? 'Produktliste aktualisiert: ' + countEl.textContent.trim()
            : 'Produktliste aktualisiert';
        }
        document.dispatchEvent(new CustomEvent('ws:products-replaced'));
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        // Fallback: klassische Navigation, der Filter geht nie verloren.
        window.location.href = url;
      })
      .finally(function () {
        if (activeController === ctrl) {
          var p = document.getElementById('ws-produkte');
          if (p) p.classList.remove('ws-products--loading');
          activeController = null;
        }
      });
  }
})();
